
<template>
  <div>
    <div class="title">
      Pagamento por PIX
    </div>
    <v-form readonly v-if="item">
      <v-text-field readonly :value="Number(item.total_amount).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})" prepend-icon="mdi-search" label="Valor"></v-text-field>
      <v-text-field readonly :value="$moment(item.payment_date).format('DD/MM/YYYY HH:mm')" prepend-icon="mdi-search" label="Pago em"></v-text-field>
      
      <!-- <v-text-field readonly :value="item.envelope_name || 'Ainda sem envelope' " prepend-icon="mdi-search" label="Envelope"></v-text-field> -->
      
      <v-text-field readonly :value="solution_map[item.extras.solution]" prepend-icon="mdi-search" label="Solução"></v-text-field>
      <div v-if="item.extras.place_name">
        <v-text-field readonly :value="item.extras.place_name" prepend-icon="mdi-search" label="Local"></v-text-field>
      </div>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import SolutionMap from '@/_backoffice/_registrations/mixins/solution_map.js'

export default {
  name: 'PixDetail',
  mixins: [SolutionMap],
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      key: null
    }
  },
  methods: {
    names() {
      
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>